import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';

import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';

import { filter } from 'rxjs/operators';
import { distinctUntilChanged, skip } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NavbarComponent } from '../../../components/layout/navbar/navbar.component';
import { FooterComponent } from '../../../components/layout/footer/footer.component';
import { AccessibilityNavComponent } from '../../../components/layout/accessability-nav/accessibility-nav.component';
import { NgClass } from '@angular/common';
import { routes } from '../../../constants/routes';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { SeoService } from '../../../services/seo.service';
import { CachingService } from '../../../services/caching.service';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    AccessibilityNavComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit {
  renderLandingContent = true;
  renderFooterContent = true;
  isHomePage = false;
  private readonly destroyRef = inject(DestroyRef);
 
  constructor(
    private seoService: SeoService,
    private cdr: ChangeDetectorRef,
    private cachingService: CachingService,
    private router: Router,
  ) { }

  

  ngOnInit(): void {
    const { title, description, canonicalUrl } =
      pageSeoInfo['landing'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);

    // Initial load
    this.updateHomePageStatus(this.router.url);

    // Every navigation
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd =>
            event instanceof NavigationEnd
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        this.updateHomePageStatus(event.urlAfterRedirects);
      });

    this.subscribeToLanguageChange();
  }

  private updateHomePageStatus(url: string): void {
    this.isHomePage = url === '/home' || url === '/home/';
  }

  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshAppContent();
      });
  }
  private refreshAppContent(): void {
    // Always refresh footer
    this.renderFooterContent = false;
    this.cdr.detectChanges();

    // Refresh router/page content only when NOT home
    if (!this.isHomePage) {
      this.renderLandingContent = false;
      this.cdr.detectChanges();
    }

    setTimeout(() => {
      // Always restore footer
      this.renderFooterContent = true;

      // Restore page content only when it was refreshed
      if (!this.isHomePage) {
        this.renderLandingContent = true;
      }

      this.cdr.detectChanges();
    });
  }
}